import { gql } from '@apollo/client';

export const GET_INCLUDED_BENEFITS = gql`
  query PROPOSAL_SERVICE_V3_getIncludedBenefits($templateId: String!) {
    getIncludedBenefits(templateId: $templateId)
  }
`;

export const GENERATE_BENEFIT_SUMMARIES = gql`
  mutation PROPOSAL_SERVICE_V3_generateBenefitSummaries(
    $sponsorId: String
    $catalogId: String!
    $productTemplate: ProductTemplate!
    $includedBenefits: Map!
  ) {
    generateBenefitSummaries(
      sponsorId: $sponsorId
      catalogId: $catalogId
      productTemplate: $productTemplate
      includedBenefits: $includedBenefits
    )
  }
`;

export const RESET_BENEFIT_SUMMARIES = gql`
  mutation PROPOSAL_SERVICE_V3_resetBenefitSummaries($templateId: String!) {
    resetBenefitSummaries(templateId: $templateId)
  }
`;

export const GET_PROPOSAL_STATE = gql`
  query PROPOSAL_SERVICE_V3_getProposalState($cartId: String!) {
    getProposalState(cartId: $cartId) {
      cartId
      lastUpdateTime
      generateProposalAnswers
      estimatedCost {
        rateResponse {
          portfolioId
          productId
          rates
        }
        estimatedCost
        employeeCount
      }
    }
  }
`;

export const GET_PROPOSAL_STATUS = gql`
  query PROPOSAL_SERVICE_V3_getProposalStatus($cartId: String!, $lastUpdateTime: String!) {
    getProposalStatus(cartId: $cartId, lastUpdateTime: $lastUpdateTime)
  }
`;

export const SAVE_GENERATE_PROPOSAL_ANSWERS = gql`
  mutation PROPOSAL_SERVICE_V3_saveGenerateProposalAnswers($cartId: String!, $answers: Map!) {
    saveGenerateProposalAnswers(cartId: $cartId, answers: $answers)
  }
`;

export const GET_PROPOSAL_DOWNLOAD_URL = gql`
  query PROPOSAL_SERVICE_V3_getProposalDownloadURL($cartId: String!, $fileType: ProposalFileType = PDF) {
    getProposalDownloadURL(cartId: $cartId, fileType: $fileType)
  }
`;

export const GENERATE_PROPOSAL = gql`
  mutation PROPOSAL_SERVICE_V3_generateProposal($request: ProposalRequest!, $confirmedOnly: Boolean = false) {
    generateProposal(request: $request, confirmedOnly: $confirmedOnly)
  }
`;

export const SHARE_PROPOSAL = gql`
  query PROPOSAL_SERVICE_V3_shareProposal(
    $cartId: String!
    $groupId: String!
    $primaryEmail: String!
    $cc: [String]!
    $message: String!
    $cartName: String!
  ) {
    shareProposal(
      cartId: $cartId
      groupId: $groupId
      primaryEmail: $primaryEmail
      cc: $cc
      message: $message
      cartName: $cartName
    )
  }
`;

export const GET_INITIAL_SEED_BENEFIT_ZIP = gql`
  mutation PROPOSAL_SERVICE_V3_getInitialSeedBenefitsZip($sponsorId: String!) {
    getInitialSeedBenefitsZip(sponsorId: $sponsorId)
  }
`;

export const GET_PROPOSAL_UPLOAD_URL = gql`
  mutation PROPOSAL_SERVICE_V3_getProposalUploadURL($request: ProposalRequest!, $fileName: String!) {
    getProposalUploadURL(request: $request, fileName: $fileName)
  }
`;

export const GENERATE_EXHIBITS = gql`
  mutation PROPOSAL_SERVICE_V3_generateExhibits($sponsorId: String!, $effectiveDate: String!) {
    generateExhibits(sponsorId: $sponsorId, effectiveDate: $effectiveDate)
  }
`;
